import { motion } from "framer-motion";

// Scroll-triggered reveal wrapper.
export const Reveal = ({ children, delay = 0, y = 30, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

// Masked line-by-line reveal for headline typography.
export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 0.9,
            delay: delay + i * 0.11,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Overline / section eyebrow.
export const Overline = ({ children, dark = false, className = "" }) => (
  <div
    className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] ${
      dark ? "text-white/50" : "text-black/45"
    } ${className}`}
  >
    <span className={`h-px w-8 ${dark ? "bg-white/30" : "bg-black/25"}`} />
    {children}
  </div>
);
